import { FC } from "react";

import { useLogout } from "@/hooks";
import { Button, Typography } from "@/shared/ui";
import { useUIStore } from "@/stores";

import styles from "./logout-confirmation.module.scss";

const LogoutConfirmation: FC = ({}) => {
  const { logout } = useLogout();
  const closeModal = useUIStore((state) => state.actions.modal.closeModal);

  return (
    <div className={styles.container}>
      <Typography semi variant="body" align="center" color="white" className={styles.title}>
        Logging Out
      </Typography>

      <Typography variant="footnote" align="center" className={styles.description}>
        Are you sure you want to log out of your account? Your session will end, and you will need to log in again to
        access your data.
      </Typography>

      <div className={styles.controlButtons}>
        <Button fullWidth variant="primary" className={styles.negative} onClick={closeModal}>
          Cancel
        </Button>
        <Button fullWidth variant="secondary" onClick={logout}>
          Yes
        </Button>
      </div>
    </div>
  );
};

export { LogoutConfirmation };
